import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, TimeUnit } from "__generated__/graphql";

export const HourlySchema: RegistryItem = {
	[AgreementTypeEnum.Hourly]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.TimeUnit,
				timeUnit: TimeUnit.Hour,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.timeUnit": { rules: { hidden: true } },
			"calculationMethod.minimumTimeUnitsPayable": { rules: { hidden: true } },
		},
	},
};
